import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  LineController,
  BarController,
  LineElement,
  BarElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Legend,
  Tooltip,
  Filler,
} from "chart.js"

Chart.register(
  LineController,
  BarController,
  LineElement,
  BarElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Legend,
  Tooltip,
  Filler
)

export default class extends Controller {
  static targets = ["traffic", "topTenants"]
  static values = {
    labels: Array,
    sent: Array,
    delivered: Array,
    bounced: Array,
    complained: Array,
    rejected: Array,
    topLabels: Array,
    topCounts: Array,
    sentLabel: String,
    deliveredLabel: String,
    bouncedLabel: String,
    complainedLabel: String,
    rejectedLabel: String,
    problemsLabel: String,
  }

  connect() {
    this.charts = []
    this._renderTraffic()
    this._renderTop()
  }

  disconnect() {
    this.charts.forEach((c) => c.destroy())
    this.charts = []
  }

  _renderTraffic() {
    if (!this.hasTrafficTarget || !this.labelsValue?.length) return
    const chart = new Chart(this.trafficTarget, {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: [
          { label: this.sentLabelValue, data: this.sentValue, borderColor: "#3b82f6", tension: 0.2, fill: false },
          { label: this.deliveredLabelValue, data: this.deliveredValue, borderColor: "#10b981", tension: 0.2, fill: false },
          { label: this.bouncedLabelValue, data: this.bouncedValue, borderColor: "#ef4444", tension: 0.2, fill: false },
          { label: this.complainedLabelValue, data: this.complainedValue, borderColor: "#f59e0b", tension: 0.2, fill: false },
          { label: this.rejectedLabelValue, data: this.rejectedValue, borderColor: "#8b5cf6", tension: 0.2, fill: false },
        ],
      },
      options: {
        responsive: true,
        plugins: { legend: { position: "bottom" } },
        scales: { y: { beginAtZero: true, ticks: { precision: 0 } } },
      },
    })
    this.charts.push(chart)
  }

  _renderTop() {
    if (!this.hasTopTenantsTarget || !this.topLabelsValue?.length) return
    const chart = new Chart(this.topTenantsTarget, {
      type: "bar",
      data: {
        labels: this.topLabelsValue,
        datasets: [{
          label: this.problemsLabelValue,
          data: this.topCountsValue,
          backgroundColor: "rgba(239, 68, 68, 0.75)",
        }],
      },
      options: {
        indexAxis: "y",
        responsive: true,
        plugins: { legend: { display: false } },
        scales: { x: { beginAtZero: true, ticks: { precision: 0 } } },
      },
    })
    this.charts.push(chart)
  }
}
